<template>
  <transition name="fade" mode="out-in">
    <HomeMain
      v-if="step === 1"
      key="main"
      :participantId.sync="participantId"
      :step.sync="step"
    />
    <HomeGallery
      v-else-if="step === 2"
      key="gallery"
      :participantId.sync="participantId"
      :step.sync="step"
      :pictureIG.sync="picture"
    />
    <HomeThankyou
      v-else-if="step === 3"
      key="gallery"
      :pictureIG.sync="picture"
    />

  </transition>
</template>

<script>
export default {
  data() {
    return {
      participantId: -1,
      step: 1,
      picture: 1,
    };
  },
  components: {
    HomeMain: () => import(/* webpackChunkName: "home-main" */'../components/home/Main.vue'),
    HomeGallery: () => import(/* webpackChunkName: "home-gallery" */'../components/home/Gallery.vue'),
    HomeThankyou: () => import(/* webpackChunkName: "home-thankyou" */'../components/home/Thankyou.vue'),
  },
};
</script>
